import { RateCard, AssetRateCard } from "./types";

export const DEFAULT_RATES: RateCard = {
  supervisor: 760,
  concept: 800,
  dmp: 800,
  comp: 800,
  roto: 600,
  prep: 600,
  gfx: 800,
  cameraTR: 700,
  objectTR: 700,
  rANIM: 700,
  layout: 750,
  anim: 800,
  light: 850,
  fx: 850,
  onsetSupervision: 600,
};

export const DEFAULT_ASSET_RATES: AssetRateCard = {
  supervisor: 760,
  concept: 800,
  dmp: 800,
  model: 800,
  rig: 800,
  retop: 800,
  cloth: 800,
  fur: 800,
  groom: 800,
  texture: 800,
  anim: 800,
  fx: 850,
  lookdev: 850,
  photoscan: 800,
};

export const DEFAULT_SCRIPT_PROMPTS: string[] = [
  "Who are the main Characters",
  "Split the script into scenes - these are the equivalent of sequences in our bidding template so scene 1 will almost always become seq01",
  "What is the location of each scene",
  "Is it night or day",
  "Is there a description at the start of the scene",
  "Extract dialogue from each scene - we will use this later and attach it to our sequences in the bidding section",
  "What are the potential VFX requirements",
  "I also want the app to learn from old projects what the VFX tasks were when compared to the script. Each bid will build on that learning / knowledge."
];

export const TASK_LABELS: Record<string, string> = {
  supervisor: "Supervisor",
  concept: "CPT",
  dmp: "DMP",
  comp: "COMP",
  roto: "ROTO",
  prep: "PREP",
  gfx: "GRA",
  cameraTR: "Cam MM",
  objectTR: "Object MM",
  rANIM: "Roto Anim",
  layout: "Layout",
  anim: "Anim",
  light: "Light",
  fx: "FX",
  onsetSupervision: "Onset Supervision",
};

export const ASSET_TASK_LABELS: Record<string, string> = {
  supervisor: "Supervisor",
  concept: "CPT",
  dmp: "DMP",
  model: "Model",
  rig: "Rig",
  retop: "Retop",
  cloth: "Cloth",
  fur: "Fur",
  groom: "Groom",
  texture: "Texture",
  anim: "Anim",
  fx: "FX",
  lookdev: "L/dev",
  photoscan: "P/scan",
};

export const TASK_ALIASES: Record<string, string[]> = {
  shotCode: ["Shot Code", "Shot", "Code", "Shot ID", "ID", "Shot Number", "Shot #", "ShotName"],
  assetCode: ["Asset Name", "Asset", "Asset ID", "Asset Number", "Asset #", "Name", "AssetName"],
  description: ["Task Description", "Description", "Scope", "Work", "Task", "Notes", "Shot Description"],
  scopeOfWork: ["Scope of Work (Client)", "Scope of Work", "Scope of Work (Client Description)", "Client Description"],
  sceneDescription: ["Scene Description", "Scene", "Location Description"],
  frames: ["Working Duration", "Frames", "Duration", "Length", "Working Days", "WorkingDuration", "Frame Count"],
  quantity: ["Quantity", "Qty", "Count", "Units", "Amount", "Number of Shots"],
  legacy_price: ["Price", "Bid Price", "Line Price", "Line Total", "Cost", "Total Price", "Bid Total", "Amount £", "Price £"],
  assumptions: ["Assumptions", "Notes", "Bid Assumptions", "Internal Notes"],
  internalNotes: ["Bid Notes (Internal)", "Internal Notes", "Notes"],
  project_onsetSupervision: ["Onset Supervision (Days)", "Onset Supervision", "Onset Days", "Supervision Days"],
  supervisor: ["Supervisor", "Supervisor Rate", "Sup Rate", "Supervisor £", "Sup £", "Sup", "VFX Sup", "VFX Supervisor", "VFX Supervision"],
  concept: ["CPT", "Concept", "CPT Rate", "Concept Rate", "CPT £", "Concept £", "Art", "Design", "Concept Art"],
  comp: ["COMP", "Comp", "COMP Rate", "Comp Rate", "COMP £", "Comp £", "Compositing", "2D"],
  roto: ["ROTO", "Roto", "ROTO Rate", "Roto £", "Rotoscoping", "Roto Paint"],
  prep: ["PREP", "Prep", "PREP Rate", "Prep £", "Paint", "Clean Up", "Digital Prep"],
  gfx: ["GRA", "GFX", "Graphics", "GRA Rate", "GFX Rate", "GRA £", "GFX £", "Motion Graphics", "MGFX"],
  anim: ["Anim", "Anim Rate", "Anim £", "Animation", "3D Animation"],
  fx: ["FX", "FX Rate", "FX £", "Simulation", "Sim", "Particles", "Houdini"],
  onsetSupervision: ["Onset", "Onset Rate", "Onset £", "Onset Supervision Rate"],
  matchmove: ["MM", "Matchmove", "MM Rate", "MM £", "Matchmove £", "Tracking", "3D Track"],
  dmp: ["DMP", "DMP Rate", "DMP £", "Matte Painting", "Digital Matte Painting"],
  model: ["Model", "Modeling", "Model Rate", "Model £", "3D Model", "Sculpt"],
  rig: ["Rig", "Rigging", "Rig Rate", "Rig £", "Character Rig"],
  texture: ["Texture", "Texturing", "Texture Rate", "Texture £", "Surfacing", "Shaders"],
  light: ["Lighting", "Lighting Rate", "Lighting £", "Lgt", "Rendering", "Render", "Light"],
  layout: ["Layout", "Layout Rate", "Layout £"],
  production: ["Production", "Prod Rate", "Production £", "Prod £", "PM", "PC", "Coordinator"],
  rANIM: ["Roto Anim", "rANIM", "RotoAnimation"],
  lookdev: ["L/dev", "Lookdev", "Ldev", "Look Development"],
  photoscan: ["P/scan", "Photoscan", "Pscan", "Photogrammetry"],
  cameraTR: ["Cam MM", "CamTR", "Camera Track", "Camera Tracking", "Cam Track", "CameraTR"],
  objectTR: ["Object MM", "ObjTR", "Object Track", "Object Tracking", "Obj Track", "ObjectTR"],
  retop: ["Retop", "Retopology", "Retopo"],
  cloth: ["Cloth", "Cloth Sim", "Cloth Simulation"],
  fur: ["Fur", "Fur Sim", "Fur Simulation", "Hair"],
  groom: ["Groom", "Grooming", "Hair Groom"],
  ts_quoteName: ["Quote Name", "Estimate Name", "Bid Name", "Quote Title"],
  ts_quoteDate: ["Quote Date", "Estimate Date", "Bid Date", "Date"],
  ts_version: ["Version", "Bid Version", "Quote Version", "Estimate Version"],
  ts_cost_shotTotal: ["Shot Total", "Shots Total", "Shots"],
  ts_cost_assetTotal: ["Asset Total", "Assets Total", "Assets"],
  ts_cost_onsetTotal: ["Onset Total", "Onset Supervision", "Onset Supervision Total", "Onset"],
  ts_cost_grandTotal: ["Grand Total", "Quote Total", "Estimate Total", "Total"],
  ts_cost_shotCount: ["Shot Count", "Shots Count", "Total Shots"],
  ts_cost_assetCount: ["Asset Count", "Assets Count", "Total Assets"],
  ts_cost_currency: ["Currency", "Quote Currency", "Estimate Currency"],
  ts_summary: ["Summary", "Project Summary", "Brief", "Overview", "Project Overview"],
  ts_approach: ["Approach", "Creative Approach", "Methodology", "VFX Approach"],
  ts_assumptions: ["Assumptions", "Bid Assumptions", "Project Assumptions"],
  ts_clarifications: ["Clarifications", "Notes"],
  ts_exclusions: ["Exclusions", "Out of Scope"],
  ts_termsAndConditions: ["Terms and Conditions", "T&Cs", "Terms & Conditions", "Terms", "Legal"],
  status: ["Status", "Shot Status", "Asset Status", "State", "Progress", "Active", "On/Off"],
  project_title: ["Project Title", "Project Name", "Show", "Title", "Job Name"],
  project_client: ["Client", "Customer", "Client Name"],
  project_production_company: ["Production Company", "Prod Co", "Production Co"],
};
